import { type ReactNode } from 'react';

import { CreateCharacterPromoCard } from './create-character-promo-card';
import { UpgradePromoCard } from './upgrade-promo-card';

/** Insert a promo card after every Nth character card. */
const PROMO_EVERY = 6;

/**
 * Weave the two promo cards (Premium upgrade + Create character) evenly through
 * a list of character-card nodes: one promo after every PROMO_EVERY characters,
 * alternating between the two so they're distributed across the whole grid.
 */
export function withPromoCards(characterNodes: ReactNode[]): ReactNode[] {
  let promoCount = 0;

  return characterNodes.flatMap((node, index) => {
    if ((index + 1) % PROMO_EVERY !== 0) return [node];

    const Promo =
      promoCount++ % 2 === 0 ? UpgradePromoCard : CreateCharacterPromoCard;

    return [node, <Promo key={`promo-${index}`} />];
  });
}
